/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export interface paths {
  "/api/healthcheck": {
    get: operations["GetApiHealthcheck"];
  };
  "/api/v3/auth/signup": {
    post: operations["PostApiV3AuthSignup"];
  };
  "/api/v4/user": {
    get: operations["GetApiV4User"];
  };
  "/api/v4/user/onboarding": {
    post: operations["PostApiV4UserOnboarding"];
  };
  "/api/v4/user/onboarding-checklist": {
    /** Four step flags and closed flag. `create_account` is always completed for an authorized user, `first_ftd` is completed by the first FTD event, `view_offers` and `get_promo` are marked by the client. */
    get: operations["GetApiV4UserOnboardingChecklist"];
  };
  "/api/v4/user/onboarding-checklist/close": {
    /** Allowed only when all four steps are completed. A repeated call for a closed checklist answers 200 without changes. */
    post: operations["PostApiV4UserOnboardingChecklistClose"];
  };
  "/api/v4/user/onboarding-checklist/steps/{step}": {
    /** Idempotent: a repeated call answers 200 and keeps the first completion date. Computed steps `create_account` and `first_ftd` are rejected with 400. */
    put: operations["PutApiV4UserOnboardingChecklistStepsStep"];
  };
}

export interface components {
  schemas: {
    AlternativeContact: {
      /** @enum {string} */
      type:
        | "none"
        | "skype"
        | "msteams"
        | "telegram"
        | "facebook"
        | "whatsapp"
        | "qq"
        | "viber"
        | "wechat"
        | "weibo"
        | "line"
        | "email";
      value: string;
    };
    /**
     * @description Checklist steps the client can mark as completed
     * @enum {string}
     */
    EnumOnboardingChecklistStep: "view_offers" | "get_promo";
    /** @enum {string} */
    EnumUserLegalType: "legal" | "individual";
    /** @enum {string} */
    EnumUserProgram: "affiliate" | "ib";
    /** @enum {string} */
    EnumUserType: "affiliate" | "employee";
    Error: {
      error?: components["schemas"]["ErrorItem"];
    };
    ErrorField: {
      /** @description translation key of error */
      key?: string;
      params?: { [key: string]: string };
    };
    /**
     * @example {
     *   "_global": {
     *     "key": "api_error.rate_limit",
     *     "params": {
     *       "until": 1551908007642
     *     }
     *   },
     *   "fields": {
     *     "name": {
     *       "key": "api_error.validation_is_int",
     *       "params": {
     *         "value": "whatever was passed as non int"
     *       }
     *     }
     *   }
     * }
     */
    ErrorItem: {
      _global?: components["schemas"]["ErrorField"];
      fields?: { [key: string]: components["schemas"]["ErrorField"] };
    };
    HealthcheckResponse: {
      alive: boolean;
    };
    Manager: {
      alt_contact: components["schemas"]["AlternativeContact"][];
      first_name: string;
      /** Format: int64 */
      id: number;
      is_online: boolean;
      last_name?: string;
      leave?: {
        /** Format: date-time */
        from: string;
        /** @enum {string} */
        leave_type: "none" | "trip" | "vacation" | "sick" | "holidays";
        /** Format: date-time */
        to: string;
      };
      photo?: string;
      source?: string;
      working_hours: {
        from: string;
        timezone: string;
        to: string;
      };
    };
    OnboardingChecklist: {
      closed: boolean;
      steps: components["schemas"]["OnboardingChecklistSteps"];
    };
    OnboardingChecklistResponse: {
      data: components["schemas"]["OnboardingChecklist"];
    };
    OnboardingChecklistSteps: {
      /** @description Always true for an authorized user */
      create_account: boolean;
      /** @description Set by the first FTD event, not by the client */
      first_ftd: boolean;
      get_promo: boolean;
      view_offers: boolean;
    };
    OnboardingPost: {
      alt_contact: components["schemas"]["AlternativeContact"][];
      country_code: string;
      legal_profile:
        | components["schemas"]["UserProfileLegal"]
        | components["schemas"]["UserProfileIndividual"];
      /** @enum {string} */
      monthly_leads_count?: "gte1" | "gte3" | "gte11" | "gte100";
      partnership_experience?: string;
      program: components["schemas"]["EnumUserProgram"];
      support_language: string;
      traffic_regions: string;
      traffic_sources: string;
      /** @enum {string} */
      working_experience: "yes" | "no";
    };
    Signup: {
      aff_track?: string;
      email: string;
      is_agreement_signed: boolean;
      /** @description for internal usage */
      keyword?: string;
      password: string;
      preferable_lang: string;
      /**
       * Format: int64
       * @description for referral system
       */
      ref_account_id?: number;
      /** @description user referrer url */
      referrer?: string;
      site: string;
      /** @description for internal usage */
      source?: string;
    };
    SignupResponse: {
      /** Format: int64 */
      id: number;
    };
    UserProfile: {
      alt_contact: components["schemas"]["AlternativeContact"][];
      /** Format: date */
      birthdate?: string;
      country_code: string;
      email: string;
      /** Format: int64 */
      id: number;
      is_agreement_signed: boolean;
      is_confirmed: boolean;
      is_doc_verified: boolean;
      /** @description the affiliate has closed the dashboard onboarding checklist */
      is_onboarding_checklist_closed: boolean;
      is_onboarding_passed: boolean;
      is_phone_confirmed: boolean;
      is_subscribed_to_news: boolean;
      legal_profile:
        | components["schemas"]["UserProfileLegal"]
        | components["schemas"]["UserProfileIndividual"];
      manager?: components["schemas"]["Manager"];
      nick_name?: string;
      phone: string;
      program: components["schemas"]["EnumUserProgram"];
      /** Format: date-time */
      registered_at: string;
      site_id: number;
      subaffiliate_percent: number;
      support_language: string;
      ui_language: string;
      user_type: components["schemas"]["EnumUserType"];
    };
    UserProfileIndividual: {
      first_name: string;
      last_name: string;
      legal_type: components["schemas"]["EnumUserLegalType"];
    };
    UserProfileLegal: {
      company_name: string;
      legal_type: components["schemas"]["EnumUserLegalType"];
      representative_first_name: string;
      representative_last_name: string;
    };
  };
  parameters: {
    /** @description Clickable checklist step */
    OnboardingChecklistStep: components["schemas"]["EnumOnboardingChecklistStep"];
  };
}

export interface operations {
  GetApiHealthcheck: {
    responses: {
      /** Successful operation with token in cookie */
      200: {
        content: {
          "application/json": components["schemas"]["HealthcheckResponse"];
        };
      };
      /** Unexpected Error */
      400: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      500: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  PostApiV3AuthSignup: {
    responses: {
      /** Successful operation */
      201: {
        content: {
          "application/json": components["schemas"]["SignupResponse"];
        };
      };
      /** Bad request */
      400: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
    requestBody: {
      content: {
        "application/json": components["schemas"]["Signup"];
      };
    };
  };
  GetApiV4User: {
    responses: {
      /** Successful operation */
      200: {
        content: {
          "application/json": components["schemas"]["UserProfile"];
        };
      };
      /** Unauthorized */
      401: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  PostApiV4UserOnboarding: {
    responses: {
      /** Success */
      204: never;
      /** Bad request */
      400: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
    requestBody: {
      content: {
        "application/json": components["schemas"]["OnboardingPost"];
      };
    };
  };
  /** Four step flags and closed flag. `create_account` is always completed for an authorized user, `first_ftd` is completed by the first FTD event, `view_offers` and `get_promo` are marked by the client. */
  GetApiV4UserOnboardingChecklist: {
    responses: {
      /** Successful operation */
      200: {
        content: {
          "application/json": components["schemas"]["OnboardingChecklistResponse"];
        };
      };
      /** Forbidden */
      403: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  /** Allowed only when all four steps are completed. A repeated call for a closed checklist answers 200 without changes. */
  PostApiV4UserOnboardingChecklistClose: {
    responses: {
      /** Checklist state after closing */
      200: {
        content: {
          "application/json": components["schemas"]["OnboardingChecklistResponse"];
        };
      };
      /** Checklist is not completed: `error._global.key` is `api_error.bad_request`, `error._global.params.message` is `api_error.onboarding_checklist_is_not_completed` */
      400: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Forbidden */
      403: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  /** Idempotent: a repeated call answers 200 and keeps the first completion date. Computed steps `create_account` and `first_ftd` are rejected with 400. */
  PutApiV4UserOnboardingChecklistStepsStep: {
    parameters: {
      path: {
        /** Clickable checklist step */
        step: components["parameters"]["OnboardingChecklistStep"];
      };
    };
    responses: {
      /** Checklist state after the step is marked */
      200: {
        content: {
          "application/json": components["schemas"]["OnboardingChecklistResponse"];
        };
      };
      /** Bad request */
      400: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Forbidden */
      403: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
}

export interface external {}

export enum ApiPaths {
  GetApiHealthcheck = "/api/healthcheck",
  PostApiV3AuthSignup = "/api/v3/auth/signup",
  GetApiV4User = "/api/v4/user",
  PostApiV4UserOnboarding = "/api/v4/user/onboarding",
  GetApiV4UserOnboardingChecklist = "/api/v4/user/onboarding-checklist",
  PostApiV4UserOnboardingChecklistClose = "/api/v4/user/onboarding-checklist/close",
  PutApiV4UserOnboardingChecklistStepsStep = "/api/v4/user/onboarding-checklist/steps/:step",
}
